var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaybutton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#f5a623",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.001c-.045 0-7.457.003-12 0h12zm-12 0c-4.551.003-11.979 0-12 0h12zm-12-12C-.032 3.353 3.365.008 12 .001c8.635.007 12.032 3.352 12 12 .032 8.648-3.365 11.994-12 12-8.635-.006-12.032-3.352-12-12zm24-12H12c4.543-.003 11.955 0 12 0zm-12 0c-4.551-.003-11.979 0-12 0h12z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiNmNWE2MjMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIHNlcmlmOmlkPSJzaGFwZSAxNyIgZD0iTTI0IDI0LjAwMWMtLjA0NSAwLTcuNDU3LjAwMy0xMiAwaDEyem0tMTIgMGMtNC41NTEuMDAzLTExLjk3OSAwLTEyIDBoMTJ6bS0xMi0xMmMtLjAzMi04LjY0OCAzLjM2NS0xMS45OTMgMTItMTIgOC42MzUuMDA3IDEyLjAzMiAzLjM1MiAxMiAxMiAuMDMyIDguNjQ4LTMuMzY1IDExLjk5NC0xMiAxMi04LjYzNS0uMDA2LTEyLjAzMi0zLjM1Mi0xMi0xMnptMjQtMTJoLTEyYzQuNTQzLS4wMDMgMTEuOTU1IDAgMTIgMHptLTEyIDBjLTQuNTUxLS4wMDMtMTEuOTc5IDAtMTIgMGgxMnoiLz48L3N2Zz4=";
export { SvgPaybutton as ReactComponent };